import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RefreshButton } from '@zenlayer/portal-utils';
import { Button, DatePicker, Icon, Layout, Space, SuperSearch, Table, message, notification, } from '@zenlayer/zen-design';
import dayjs, { time2utc } from '@zenlayer/zen-design/esm/_util/day';
import { DEFAULT_pageSize } from '@zenlayer/zen-design/esm/hooks/useRequest';
import { ExportButton, SetColumnButton, useSetColumn, } from '@zenlayer/zen-design/esm/table';
import t from '@zenlayer/zen-intl18';
import { useReactive, useRequest } from 'ahooks';
import { isEmpty, last } from 'ramda';
import { useEffect, useState } from 'react';
import { exportAuditlogList, getAuditlogList, } from '../../api/auditlog';
import { onOpenDetail } from '../detail-drawer';
import { useColumns, useConfiguration } from './config';
import { useAuditLogDetail } from './detail';
import '@zenlayer/zen-design-icons/assets/direction/LeftLine.svg';
import '@zenlayer/zen-design-icons/assets/direction/RightLine.svg';
import '@zenlayer/zen-design/esm/date-picker/style';
const AuditLogMain = ({ userUid, isDefaultPartner, inDetail, openDetail, dataAttrs, }) => {
    const [currentPageNum, setCurrentPageNum] = useState(1);
    const params = useReactive({
        startTime: time2utc(dayjs().subtract(7, 'd').startOf('d')), //默认查7天
        endTime: time2utc(dayjs().endOf('d')),
        pageSize: DEFAULT_pageSize,
    });
    const ListRequest = useRequest((p) => {
        const _params = p;
        if (inDetail?.resUid) {
            _params.resUid = inDetail?.resUid;
        }
        return getAuditlogList(_params);
    }, {
        manual: true,
        onSuccess: (res) => {
            if (res.success) {
                //
            }
            else {
                notification.error({ description: res.msg });
            }
        },
    });
    const tableData = isEmpty(ListRequest.data?.data) || !ListRequest.data?.data
        ? []
        : ListRequest.data.data;
    useEffect(() => {
        ListRequest.run(params);
    }, []);
    const _columns = useColumns({
        params,
        isDefaultPartner,
        inDetail: !!inDetail,
        openDetail,
    });
    const { columns, exportOpts, ...setColumnButtonProps } = useSetColumn({
        id: 'systemLog-auditLog-list',
        userUid: userUid || 'inDetail',
        version: '1.0.0',
        columns: _columns,
    });
    const configuration = useConfiguration({ inDetail: !!inDetail });
    const content = (_jsxs(Layout.ListLayoutBody, { search: _jsxs(Space, { align: "start", children: [_jsx(SuperSearch, { ...dataAttrs?.superSearch, width: 400, value: params, configuration: configuration, onSearch: (p) => {
                        setCurrentPageNum(1);
                        params.resEvent = p.resEvent;
                        params.resUid = p.resUid;
                        params.clientIP = p.clientIP;
                        params.userUuid = p.userUuid;
                        params.lastPage = undefined; //不传代表首页
                        params.sortValues = undefined; //不传代表首页
                        ListRequest.run(params);
                    } }), _jsx(DatePicker, { ...dataAttrs?.datePicker, width: 440, size: "s", rangePicker: true, showTime: true, ranges: {
                        [t('GyHB9tBVyCRT')]: [
                            dayjs().startOf('day'),
                            dayjs().endOf('day'),
                        ],
                        [t('rb8c2ApYjCvd')]: [
                            dayjs().subtract(7, 'day').startOf('day'),
                            dayjs().endOf('day'),
                        ],
                        [t('y4ISlO-47VfL')]: [
                            dayjs().subtract(15, 'day').startOf('day'),
                            dayjs().endOf('day'),
                        ],
                        [t('D6z3wBOT2eD3')]: [
                            dayjs().startOf('month'),
                            dayjs().endOf('day'),
                        ],
                        [t('my-jL9cfZ6Ul')]: [
                            dayjs().subtract(1, 'month').startOf('month'),
                            dayjs().subtract(1, 'month').endOf('month'),
                        ],
                    }, disabledDate: (current) => {
                        return (current > dayjs().endOf('d') ||
                            current < dayjs().subtract(90, 'd').startOf('d'));
                    }, value: [dayjs(params.startTime), dayjs(params.endTime)], onChange: (v) => {
                        if (v) {
                            if (dayjs(v[1]).diff(dayjs(v[0]), 'd', true) > 31) {
                                message.error({ content: t('Qd4TaXEjXyEA') });
                                return;
                            }
                            setCurrentPageNum(1);
                            params.startTime = time2utc(v[0]);
                            params.endTime = time2utc(v[1]);
                            params.lastPage = undefined; //不传代表首页
                            params.sortValues = undefined; //不传代表首页
                            ListRequest.run(params);
                        }
                    } })] }), action: _jsxs(Button.Group, { size: "s", children: [!inDetail && _jsx(SetColumnButton, { ...setColumnButtonProps }), _jsx(ExportButton, { ...dataAttrs?.export, hidenAllRange: true, exportOpts: exportOpts, currentListParams: {}, onExport: async (_, data) => {
                        const _parmas = {
                            fieldValueList: data,
                            esDocIdList: tableData.map((i) => i.docId),
                        };
                        const { status } = await exportAuditlogList(_parmas);
                        const success = status === 200;
                        if (status === 200) {
                            notification.success();
                        }
                        return success;
                    } }), _jsx(RefreshButton, { ...dataAttrs?.refresh, loading: ListRequest.loading, onClick: ListRequest.refresh })] }), children: [_jsx(Table, { loading: ListRequest.loading, dataSource: tableData, rowKey: "docId", columns: columns }), _jsxs(Space, { className: "mt-2", block: true, style: { justifyContent: 'flex-end' }, children: [_jsx(Button, { type: "normal", textBaseColor: true, size: "s", disabled: currentPageNum === 1, onClick: () => {
                            setCurrentPageNum(currentPageNum - 1);
                            params.lastPage = true; //上一页传true
                            params.sortValues = tableData[0]?.sortValues; //不传代表首页
                            ListRequest.run(params);
                        }, children: _jsxs(Space, { block: true, children: [_jsx(Icon, { type: "direction/LeftLine", block: true, fontSize: 16 }), _jsx("span", { children: t('wQH63MrHVn9H') })] }) }), _jsx(Button, { type: "normal", textBaseColor: true, size: "s", disabled: tableData.length < params.pageSize, onClick: () => {
                            setCurrentPageNum(currentPageNum + 1);
                            params.lastPage = false; //下一页传false
                            params.sortValues = last(tableData).sortValues; //不传代表首页
                            ListRequest.run(params);
                        }, children: _jsxs(Space, { block: true, children: [_jsx("span", { children: t('LpBPWcaHumjm') }), _jsx(Icon, { type: "direction/RightLine", block: true, fontSize: 16 })] }) })] })] }));
    if (inDetail) {
        return content;
    }
    return (_jsx(Layout.ListLayout, { title: t('7t4027HCPMUK'), whatIsUrl: isDefaultPartner
            ? 'https://docs.console.zenlayer.com/welcome/platform/audit-logs'
            : undefined, subtitle: t('HOyWirDxKPwG'), children: content }));
};
export const AuditLog = (props) => {
    const { open } = useAuditLogDetail();
    return _jsx(AuditLogMain, { ...props, openDetail: open });
};
export const AuditLogInDetail = (props) => {
    return (_jsx(AuditLogMain, { ...props, openDetail: (query) => onOpenDetail(query, { path: '/systemLog/auditLog' }) }));
};
AuditLog.authOperation = 'dashboard:listAuditLog';
AuditLogInDetail.authOperation = 'dashboard:listAuditLog';
